<template>
  <div>
  <p v-if="notification.statusId < 3" style="font-size:14px">Please check the following overview information about this Forest Operation Notification.
  If you need to make corrections, please return to the Overview page.
  </p>
    <div v-if="notification.certificationMethodId" class="row-details mb-2">
      <span class="text-primary mr-3">Certification Method:</span>
      <span class="align-items-center contact-detail-value">{{certificationMethods[notification.certificationMethodId]}}</span>
    </div>
    <DetailRow
      label="Operation Start Date"
      :value="notification.operationStartDate | dateString"
    />
    <ul v-if="isOperationStartDateFuture">
      <li>The number for this notification will not display for you before this start date. If you need a Notification Number sooner, pick a start date that begins sooner for this notification.
      </li>
    </ul>
    <DetailRow
      label="Operation End Date"
      :value="notification.operationEndDate | dateString"
    />
    <DetailRow
      label="Town, Township, or Plantation"
      :value="getName(notification.townGeocodeNum)"
    />
    <DetailRow
      label="County"
      :value="getProperty(notification.townGeocodeNum, 'countyName')"
    />
    <DetailRow
      label="Name of nearest all-weather road"
      :value="notification.roadName"
    />
    <DetailRow
      label="Property Parcel Acreage"
      :value="`${$options.filters.numberString(notification.parcelAcreage)} acres`"
    />
    <ul class="summary-list mb-0">
      <li>
        This parcel <strong>WAS {{notification.purchased ? '' : 'NOT '}}</strong>
        purchased within the past five years.
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import LookupModules from '@/store/moduleConfig';
import DetailRow from '@/components/DetailRow.vue';
import CertMethods from '@/mixins/CertificationMethods';

export default {
  name: 'OverviewDetails',
  mixins: [CertMethods],
  components: {
    DetailRow,
  },
  props: {
    notification: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    ...mapGetters(LookupModules.TOWNS.namespace, ['getName', 'getProperty']),
    isOperationStartDateFuture() {
      return this.notification.operationStartDate
        ? moment(this.notification.operationStartDate).isAfter(moment(), 'day')
        : false;
    },
  },
};
</script>
